import { Button } from "@/components/ui/button"
import type { DiagnosticActivity } from "@/services/api/odin/activities/diagnostic/study-session/update"

interface DiagnosticFeedbackFooterProps {
  activity: DiagnosticActivity
  onRetry: () => void
  onContinueStudying: () => void
  isPending: boolean
}

export default function DiagnosticFeedbackFooter({
  activity,
  onRetry,
  onContinueStudying,
  isPending,
}: DiagnosticFeedbackFooterProps) {
  const isApproved = activity.feedback.scorePercentage >= activity.feedback.approvalScore
  return (
    <footer className="flex w-full px-4 pb-4">
      <div className="mx-auto flex w-full flex-col items-center gap-3 md:max-w-md">
        {isApproved ? (
          <Button size="lg" className="w-full" onClick={onContinueStudying}>
            Continuar estudiando
          </Button>
        ) : (
          <>
            <Button size="lg" className="w-full" onClick={onRetry} disabled={isPending}>
              Reintentar
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="w-full"
              onClick={onContinueStudying}
              disabled={isPending}
            >
              Continuar estudiando
            </Button>
          </>
        )}
      </div>
    </footer>
  )
}
